module.exports = {
	pageTopFixed: function(scrollPos) {
		var pageTop = $('.js_pageTop');
		var scrollHeight = $(document).height(),
				scrollPosition = $(window).height() + scrollPos,
				footerHeight = $('footer').height() - 103;

		if (scrollHeight - scrollPosition  <= footerHeight ){
			var bw = $('body').width();

			pageTop.removeClass('is_fixed');
			if(768 < bw < 1200) {
				pageTop.css('left', '1113px');
			}
		} else {
			pageTop.addClass('is_fixed');
			if(768 < bw < 1200) {
				var leftPos = $(window).scrollLeft(),
						leftValue = 1113 - leftPos;
				pageTop.css('left', leftValue);
			}
		}
	},
	pageTopDisplay: function(scrollPos) {
		var pageTop = $('.js_pageTop');
		if(scrollPos > 150) {
			pageTop.fadeIn();
		} else {
			pageTop.fadeOut();
		}
	},
	gotoTop: function() {
		$('body,html').animate({scrollTop: 0}, 500);
	}
}




//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/footer.js
// module id = 5
// module chunks = 0